export const NAVIGATION_BUTTON_CLICKED = 'action.navigation.button.clicked';
export const UPDATE_NAVIGATION_SECTIONS = 'action.navigation.update.sections';

export const navigationButtonClicked = button => {
    return {
        type: NAVIGATION_BUTTON_CLICKED,
        button,
    };
};

export const updateNavigationSections = sections => {
    return {
        type: UPDATE_NAVIGATION_SECTIONS,
        sections,
    };
};
